import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "container py-5",
  style: {"max-width":"960px"}
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "form-check form-switch m-0 d-flex align-items-center gap-2" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = {
  class: "form-check-label small",
  for: "modeSwitchWallet"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "card p-4" }
const _hoisted_9 = { class: "row g-3 align-items-center" }
const _hoisted_10 = { class: "col-md-8" }
const _hoisted_11 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_12 = { class: "small" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "text-muted-token small mt-2" }
const _hoisted_15 = { class: "row g-4 mt-3" }
const _hoisted_16 = { class: "col-12 col-lg-7" }
const _hoisted_17 = { class: "card p-4 h-100" }
const _hoisted_18 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_19 = { class: "d-flex align-items-center gap-2" }
const _hoisted_20 = {
  key: 0,
  class: "small text-muted-token"
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted-token small"
}
const _hoisted_22 = {
  key: 2,
  class: "text-danger small"
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = {
  key: 0,
  class: "text-muted-token small"
}
const _hoisted_25 = { class: "list-unstyled mb-0" }
const _hoisted_26 = { class: "d-flex align-items-center gap-2" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "fw-semibold" }
const _hoisted_29 = { class: "small text-muted-token" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "fw-semibold" }
const _hoisted_32 = { class: "small" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "col-12 col-lg-5" }
const _hoisted_35 = { class: "card p-4 h-100" }
const _hoisted_36 = {
  key: 0,
  class: "small text-muted-token"
}
const _hoisted_37 = {
  key: 1,
  class: "text-muted-token small"
}
const _hoisted_38 = {
  key: 2,
  class: "text-danger small"
}
const _hoisted_39 = { key: 3 }
const _hoisted_40 = {
  key: 0,
  class: "text-muted-token small"
}
const _hoisted_41 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_42 = { class: "border rounded p-2 h-100 d-flex flex-column" }
const _hoisted_43 = {
  class: "ratio ratio-1x1 mb-2 bg-body-tertiary d-flex align-items-center justify-content-center overflow-hidden",
  style: {"border-radius":"8px"}
}
const _hoisted_44 = ["src", "alt"]
const _hoisted_45 = {
  key: 1,
  class: "bi bi-image text-muted",
  style: {"font-size":"24px"}
}
const _hoisted_46 = { class: "small fw-semibold text-truncate" }
const _hoisted_47 = { class: "small text-muted-token" }
const _hoisted_48 = { class: "mt-auto pt-1" }
const _hoisted_49 = ["href"]

import { computed, onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { useWalletStore } from '../stores/wallet';
import { useChainStore } from '../stores/chain';
import { useTokens } from '../composables/tokens';
import { useNfts } from '../composables/nfts';
import { formatRelativeTime } from '../utils/time';

const TESTNET_ID = 11155111;

export default /*@__PURE__*/_defineComponent({
  __name: 'Wallet',
  setup(__props) {

const wallet = useWalletStore();
wallet.init();
const chain = useChainStore();
chain.init();

const chains = computed(() => chain.supported);
const selectedChainId = ref<number>(chain.selectedId);
const DEFAULT_MAINNET_ID = Number((process.env.VUE_APP_DEFAULT_CHAIN_ID as string) || '1');
const isTestnet = computed(() => chain.selectedId === TESTNET_ID);

async function setMode(toTestnet: boolean) {
  const targetId = toTestnet ? TESTNET_ID : DEFAULT_MAINNET_ID;
  selectedChainId.value = targetId;
  await onChainChange();
}
async function onModeSwitchChange(ev: Event) {
  const target = ev.target as HTMLInputElement;
  await setMode(!!target.checked);
}
async function onChainChange() {
  chain.select(selectedChainId.value);
  try { await wallet.ensureChain(chain.current.chain); } catch {}
}

const { tokens, balances, loading: loadingRef, error: errorRef, load, refreshBalances, serverMeta, refreshServerTokens } = useTokens();
const { items: nftItems, loading: loadingNftsRef, error: nftErrorRef, load: loadNfts, meta: nftsMetaRef } = useNfts();
const loadingTokens = computed(() => loadingRef.value);
const tokensError = computed(() => errorRef.value);
const tokenItems = computed(() => (tokens.value || []).map(t => ({
  ...t,
  balance: balances.value[t.address] || '0'
})));
const tokenQuery = ref('');
const filteredTokenItems = computed(() => {
  const q = tokenQuery.value.trim().toLowerCase();
  if (!q) return tokenItems.value;
  return tokenItems.value.filter((t: any) => {
    return (
      (t.symbol && String(t.symbol).toLowerCase().includes(q)) ||
      (t.name && String(t.name).toLowerCase().includes(q)) ||
      (t.address && String(t.address).toLowerCase().includes(q))
    );
  });
});
const nfts = computed(() => nftItems.value || []);
const loadingNfts = computed(() => loadingNftsRef.value);
const nftError = computed(() => nftErrorRef.value);
const tokensMeta = computed(() => serverMeta.value || null);
const nftsMeta = computed(() => nftsMetaRef.value || null);

onMounted(async () => {
  await load();
  await refreshBalances();
  await loadNfts();
  startPolling();
});

watch(() => wallet.address, async () => {
  await load();
  await refreshBalances();
  await loadNfts();
});
watch(() => chain.selectedId, async () => {
  selectedChainId.value = chain.selectedId;
  await load();
  await refreshBalances();
  await loadNfts();
});

async function onTokensRefresh() {
  await refreshServerTokens();
  await refreshBalances();
}

async function onNftsRefresh() {
  await loadNfts(true, true);
}

const networkName = computed(() => chain.current.label);
const chainBadgeClass = computed(() => chain.current.id === TESTNET_ID ? 'badge-tinted-accent' : 'badge-tinted-primary');
const explorerBase = computed(() => chain.current.explorerBase || 'https://sepolia.etherscan.io');
const explorerAddress = computed(() => wallet.address ? `${explorerBase.value}/address/${wallet.address}` : '#');
const explorerLabel = computed(() => explorerBase.value.includes('etherscan') ? 'View on Etherscan' : 'View on Explorer');

function tokenLink(addr: string) {
  // Prefer token holdings page on *scan explorers; fallback to token page
  const base = explorerBase.value;
  if (/scan\.io|etherscan|arbiscan|polygonscan|basescan/.test(base)) {
    return wallet.address ? `${base}/token/${addr}?a=${wallet.address}` : `${base}/token/${addr}`;
  }
  return `${base}/token/${addr}`;
}

const nftTransfersUrl = computed(() => wallet.address ? `${explorerBase.value}/address/${wallet.address}#nfttransfers` : '#');
function nftLink(contract: string, tokenId: string) {
  return `${explorerBase.value}/token/${contract}?a=${wallet.address || ''}&tokenId=${tokenId}`;
}

function rel(ts?: string | null) {
  return formatRelativeTime(ts || undefined);
}

async function copyAddress() {
  if (!wallet.address) return;
  try { await navigator.clipboard.writeText(wallet.address); } catch {}
}

async function disconnect() {
  await wallet.disconnect();
}

async function connect() {
  try {
    const mod = await import('@reown/appkit/vue-core');
    const { open } = mod.useAppKit();
    await open();
  } catch {
    // fallback to hidden element open
    const btn = document.createElement('w3m-button');
    btn.style.display = 'none';
    document.body.appendChild(btn);
    (btn as any).open?.();
    setTimeout(() => btn.remove(), 2000);
  }
}

async function openWalletModal() {
  // Try to open AppKit modal if available
  try {
    const mod = await import('@reown/appkit/vue-core');
    const { open } = mod.useAppKit();
    await open();
  } catch {}
}

// Polling
let pollTimer: any = null;
function startPolling() {
  stopPolling();
  pollTimer = setInterval(async () => {
    await load();
    await refreshBalances();
    await loadNfts();
  }, 30000);
}
function stopPolling() {
  if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
}
onBeforeUnmount(stopPolling);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "fw-bold mb-0" }, "Wallet", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            id: "modeSwitchWallet",
            checked: isTestnet.value,
            onChange: onModeSwitchChange
          }, null, 40, _hoisted_5),
          _createElementVNode("label", _hoisted_6, _toDisplayString(isTestnet.value ? 'Testnet' : 'Mainnet'), 1)
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-sm w-auto",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedChainId).value = $event)),
          onChange: onChainChange
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chains.value, (c) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c.id,
              value: c.id
            }, _toDisplayString(c.label), 9, _hoisted_7))
          }), 128))
        ], 544), [
          [
            _vModelSelect,
            selectedChainId.value,
            void 0,
            { number: true }
          ]
        ]),
        (_unref(wallet).isConnected)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-outline-danger btn-sm",
              onClick: disconnect
            }, "Disconnect"))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-primary btn-sm",
              onClick: connect
            }, "Connect"))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", {
              class: _normalizeClass(['badge', chainBadgeClass.value])
            }, _toDisplayString(networkName.value), 3),
            _createElementVNode("code", _hoisted_12, _toDisplayString(_unref(wallet).address || 'Not connected'), 1),
            (_unref(wallet).address)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm btn-outline-secondary",
                  onClick: copyAddress
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "bi bi-clipboard me-1" }, null, -1),
                  _createTextVNode("Copy", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_unref(wallet).address)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "btn btn-sm btn-outline-secondary",
                  href: explorerAddress.value,
                  target: "_blank",
                  rel: "noopener"
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-box-arrow-up-right me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(explorerLabel.value), 1)
                ], 8, _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, "Chain ID: " + _toDisplayString(_unref(chain).current.id), 1)
        ]),
        _createElementVNode("div", { class: "col-md-4 text-md-end" }, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary btn-sm",
            onClick: openWalletModal
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "bi bi-gear me-1" }, null, -1),
            _createTextVNode("Wallet Settings", -1)
          ]))])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "mb-0" }, "Tokens", -1)),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "search",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tokenQuery).value = $event)),
                placeholder: "Search tokens...",
                style: {"max-width":"220px"}
              }, null, 512), [
                [
                  _vModelText,
                  tokenQuery.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                onClick: onTokensRefresh,
                title: 'Refresh detected tokens & balances'
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "bi bi-arrow-repeat" }, null, -1)
              ]))])
            ])
          ]),
          (tokensMeta.value && tokensMeta.value.updatedAt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (tokensMeta.value.cached)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Showing cached results")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Just refreshed")
                    ], 64)),
                _createTextVNode(" • Updated " + _toDisplayString(rel(tokensMeta.value.updatedAt)) + " ", 1),
                (tokensMeta.value.cooldownSecondsRemaining && tokensMeta.value.cooldownSecondsRemaining > 0 && tokensMeta.value.nextRefreshAt)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" • You can refresh again " + _toDisplayString(rel(tokensMeta.value.nextRefreshAt)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (loadingTokens.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Loading tokens…"))
            : (tokensError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(tokensError.value), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (filteredTokenItems.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (tokenQuery.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("No tokens match your search.")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("No tokens found on this network.")
                            ], 64))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTokenItems.value, (t) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: t.address,
                        class: "d-flex justify-content-between align-items-center py-2 border-bottom"
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          (t.logoURI)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: t.logoURI,
                                alt: t.symbol,
                                width: "20",
                                height: "20",
                                style: {"border-radius":"4px"}
                              }, null, 8, _hoisted_27))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_28, _toDisplayString(t.symbol), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(t.name), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(t.balance), 1),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("a", {
                              href: tokenLink(t.address),
                              target: "_blank",
                              rel: "noopener"
                            }, "View", 8, _hoisted_33)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-2" }, [
            _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "mb-0" }, "NFTs", -1)),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-secondary",
              onClick: onNftsRefresh
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "bi bi-arrow-repeat" }, null, -1)
            ]))])
          ]),
          (nftsMeta.value && nftsMeta.value.updatedAt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (nftsMeta.value.cached)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Showing cached results")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Just refreshed")
                    ], 64)),
                _createTextVNode(" • Updated " + _toDisplayString(rel(nftsMeta.value.updatedAt)) + " ", 1),
                (nftsMeta.value.cooldownSecondsRemaining && nftsMeta.value.cooldownSecondsRemaining > 0 && nftsMeta.value.nextRefreshAt)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" • You can refresh again " + _toDisplayString(rel(nftsMeta.value.nextRefreshAt)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (loadingNfts.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Loading NFTs…"))
            : (nftError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(nftError.value), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (nfts.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, "No NFTs found on this network."))
                    : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nfts.value, (n) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col-6",
                            key: n.contractAddress + ':' + n.tokenId
                          }, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                (n.image)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: n.image,
                                      alt: n.name || 'NFT',
                                      class: "w-100 h-100 object-fit-cover"
                                    }, null, 8, _hoisted_44))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_45))
                              ]),
                              _createElementVNode("div", _hoisted_46, _toDisplayString(n.name || 'NFT'), 1),
                              _createElementVNode("div", _hoisted_47, "#" + _toDisplayString(n.tokenId), 1),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("a", {
                                  href: nftLink(n.contractAddress, n.tokenId),
                                  target: "_blank",
                                  rel: "noopener",
                                  class: "small"
                                }, "View", 8, _hoisted_49)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
        ])
      ])
    ])
  ]))
}
}

})